<template>
  <h2 class="titleStepForm">Account Activity</h2>
  <div class="row">
    <div class="col-lg-6">
      <label class="font-size-14"
        >How will account be funded</label
      >
      <div class="single-select2-cstm">
        <Select2
          v-model="form.personal.accFunded"
          :class="{
            'is-invalid': v$.form.personal.accFunded.$error,
          }"
          placeholder="Select"
          :options="fundedoption"
          disabled
        />
        <div
          v-for="(personal, index) in v$.form.personal
            .accFunded.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
    <br /><br /><br /><br /><br />
    <template v-if="isPdf">
    <div class="col-12 mb-3">
      <h4 class="font-size-14">
        Are you a member of any other Credit Union / Financial
        Institution?
      </h4>
      <p class="subTitleForm">
        (Financial Institution e.g. Bank, UTC, Securities
        Company)
      </p>
      <div class="row gx-2">
        <div class="col-auto">
          <label
            for="yesAcc"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
            :class="{
              'is-invalid':
                v$.form.personal.accountActi.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.accountActi"
              value="True"
              name="accountActivity"
              class="inputRadioCstm d-none"
              id="yesAcc"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .accountActi.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noAcc"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
            :class="{
              'is-invalid':
                v$.form.personal.accountActi.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.accountActi"
              value="False"
              name="accountActivity"
              class="inputRadioCstm d-none"
              id="noAcc"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .accountActi.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="textareaShow"
        v-if="form.personal.accountActi == true"
        :class="{
          'is-invalid': v$.form.personal.accountActi.$error,
        }"
      >
        <textarea
          type="textarea"
          v-model="form.personal.accountActiDesc"
          class="form-control resize-none"
          rows="4"
          disabled
        ></textarea>
      </div>
      <div
        v-for="(personal, index) in v$.form.personal
          .accountActi.$errors"
        :key="index"
        class="invalid-feedback"
      >
        <span v-if="personal.$message">{{
          personal.$message
        }}</span>
      </div>
    </div>
    </template>
    <template v-if="!isPdf">
    <div class="col-lg-6 mb-3">
      <h4 class="font-size-14">
        Are you a member of any other Credit Union / Financial
        Institution?
      </h4>
      <p class="subTitleForm">
        (Financial Institution e.g. Bank, UTC, Securities
        Company)
      </p>
      <div class="row gx-2">
        <div class="col-auto">
          <label
            for="yesAcc"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
            :class="{
              'is-invalid':
                v$.form.personal.accountActi.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.accountActi"
              value="True"
              name="accountActivity"
              class="inputRadioCstm d-none"
              id="yesAcc"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .accountActi.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noAcc"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
            :class="{
              'is-invalid':
                v$.form.personal.accountActi.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.accountActi"
              value="False"
              name="accountActivity"
              class="inputRadioCstm d-none"
              id="noAcc"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .accountActi.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="textareaShow"
        v-if="form.personal.accountActi === 'True'"
        :class="{
          'is-invalid': v$.form.personal.accountActi.$error,
        }"
      >
        <textarea
          type="textarea"
          v-model="form.personal.accountActiDesc"
          class="form-control resize-none"
          rows="4"
          disabled
        ></textarea>
      </div>
      <div
        v-for="(personal, index) in v$.form.personal
          .accountActi.$errors"
        :key="index"
        class="invalid-feedback"
      >
        <span v-if="personal.$message">{{
          personal.$message
        }}</span>
      </div>
    </div>
    </template>
    <template v-if="isPdf">
    <div class="col-lg-6">
      <label class="font-size-14"
        >Include source of income
      </label>
      <div class="single-select2-cstm">
        <Select2
          v-model="form.personal.socuceofincome"
          :options="Incomeoption"
          disabled
        />
      </div>
    </div>
    </template>
    <template v-if="!isPdf">
    <!-- Optional field: Include source of income -->
    </template>
    <div class="col-lg-6">
      <label class="font-size-14"
        >Include the area for details to be captured.</label
      >
      <div class="single-select2-cstm">
        <input
          type="text"
          v-model="form.personal.areaofdetails"
          disabled
          class="form-control"
        />
      </div>
    </div>
    <br /><br /><br /><br />
    <div class="col-12 mb-3">
      <h3 class="mb-2 font-size-18">
        Grouping for 'anticipated level of activity'
      </h3>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="font-size-14"
              >Number of transactions</label
            >
            <input
              type="text"
              v-model="form.personal.numTrans"
              class="form-control"
              placeholder="Number of transactions"
              :class="{
                'is-invalid':
                  v$.form.personal.numTrans.$error,
              }"
              disabled
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .numTrans.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label class="font-size-14"
              >Volume of Transactions (TT$)</label
            >
            <input
              type="text"
              v-model="form.personal.volTrans"
              class="form-control"
              placeholder="Volume of Transactions (TT$)"
              :class="{
                'is-invalid':
                  v$.form.personal.volTrans.$error,
              }"
              disabled
            />
            <div
              v-for="(personal, index) in v$.form.personal
                .volTrans.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal.$message">{{
                personal.$message
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";

export default {
  name: "ReviewAccountActivity",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["fundedoption", "form", "Incomeoption"],
    validate: true,
    }),
  ],
  components: { Select2 },
};
</script>
